const popupButtons = qsa('[data-popup]')
let raf = null
let to = null
let focusAfterCloseEl = null
let template = null
let contents = null

const overlayEl = ce({
  classname: 'popup-overlay',
  listeners: {
    'click': closePopup
  }
})

const popupClose = ce({
  type: 'button',
  classname: 'popup__close',
  listeners:{
    'click': closePopup
  }
})

const popupEl = ce({
  type: 'aside',
  classname: 'popup',
})


function openPopup(popupId, focusAfterClose){
  focusAfterCloseEl = focusAfterClose
  cancelAnimationFrame(raf)
  clearTimeout(to)
  document.addEventListener('keydown',handleKeydown)

  template = document.getElementById(popupId)
  contents = template.content ? template.content.cloneNode(true) : Array.from(template.children)

  if(!contents) return
  if(Array.isArray(contents)){
    popupEl.replaceChildren(...contents, popupClose)
  }else{
    popupEl.replaceChildren(contents, popupClose)
  }
  const images = qsa('img', popupEl)
  images.forEach(imageEl => {
    if(imageEl.complete){
      imageEl.classList.add('is-loaded')
    } else {
      imageEl.addEventListener('load',()=>{
        imageEl.classList.add('is-loaded')
      })
    }
  })
  document.body.append(overlayEl, popupEl)

  forceLayout()

  raf = requestAnimationFrame(()=>{
    overlayEl.classList.add('is-visible')
    popupEl.classList.add('is-visible')
    trapFocus(popupEl)
  })
}

function closePopup(){
  cancelAnimationFrame(raf)
  clearTimeout(to)
  overlayEl.classList.remove('is-visible')
  popupEl.classList.remove('is-visible')
  document.removeEventListener('keydown',handleKeydown)
  releaseFocus(focusAfterCloseEl)

  to = setTimeout(() => {
    if(Array.isArray(contents)){
      template.replaceChildren(...contents)
    }
    overlayEl.remove()
    popupEl.remove()
  }, 300);
}

function handleKeydown(evt){
  if(evt.key === 'Escape'){
    closePopup()
  }
}


popupButtons.forEach(button => {
  const focusAfterEl = button.dataset.popupFocusAfter ? qs(button.dataset.popupFocusAfter) : button
  if(button.tagName === 'INPUT'){
    button.addEventListener('focus', () => {
      openPopup(button.dataset.popup, focusAfterEl)
    })
  } else {
    button.addEventListener('click', () => {
      openPopup(button.dataset.popup, focusAfterEl)
    })
  }

})